import {gql} from '@apollo/client'

export const GET_PAYMENT_RULES = gql`
  query GetPaymentRules($q: String, $page: Int, $limit: Int, $sortBy: String, $sortDirection: String) {
    paymentRules(q: $q, page: $page, limit: $limit, sortBy: $sortBy, sortDirection: $sortDirection) {
      collection {
        id
        description
        account {
          id
          displayName @client
          contactFullName @client
          name
          contactFirstName
          contactLastName
        }
        conditions {
          id
          fieldName
          matchType
          text
        }
      }
      metadata {
        totalCount
      }
    }
  }
`
